import * as Types from '../constants/Types';

export const getTicketSold = (filters) => ({ type: Types.TICKET_SOLD_LIST_ACTION, filters });
export const setTicketSold = (ticketSolds) => ({ type: Types.TICKET_SOLD_LIST_SUCCESS, ticketSolds});